import axios from 'axios';

// Anonymous client — no interceptor, no cookies. The token in the URL is the
// only auth. Mirrors careerService pattern.
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5148',
  timeout: 30000,
});

export const getOffer = (offerId, token) =>
  publicApi.get(`/v1/public/offers/${encodeURIComponent(offerId)}`, { params: { token } });

export const acceptOffer = (offerId, token, note) =>
  publicApi.post(`/v1/public/offers/${encodeURIComponent(offerId)}/accept`, { token, note });

export const rejectOffer = (offerId, token, reason) =>
  publicApi.post(`/v1/public/offers/${encodeURIComponent(offerId)}/reject`, { token, reason });
